export default function() {
  let ctx = {};
  let environment;
  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.MixinContext
  ) {
    environment = 'iOS';
  }
  if (window.MixinContext && window.MixinContext.getContext) {
    environment = 'Android';
  }
  switch (environment) {
    case 'iOS':
      ctx = JSON.parse(prompt('MixinContext.getContext()'));
      break;
    case 'Android':
      ctx = JSON.parse(window.MixinContext.getContext());
      break;
    default:
  }
  return {
    appearance: ctx.appearance, // dark / light
    appVersion: ctx.app_version, // mixin app version
    conversationId: ctx.conversation_id, // mixin conversation id
    currency: ctx.currency,
    immersive: ctx.immersive, // mode
    locale: ctx.locale, // language
  };
}
